import { useGetTreeById } from 'shared/hooks/trees/hooks'
import { nodeForId } from 'components/utility/TreeHelpers'

export function useNodeOrTree({
  treeId,
  versionId,
  nodeId,
}: {
  treeId: string
  versionId: string
  nodeId?: string
}) {
  const { tree } = useGetTreeById({
    treeId,
    versionId,
  })
  if (!tree) return { tree: undefined, loading: true }
  const node = nodeId && tree ? nodeForId(nodeId, tree) : undefined
  return { tree: node ?? tree, loading: false }
}
